import * as colors from './colors';
import lighttheme from './core-ui-colors';
import darktheme from './dark-core-ui-colors';
import prismDark from './prism/dark';
import prismLight from './prism/light';

export const light = {
    ...colors,
    primary: lighttheme.secondary.accent,
    secondary: lighttheme.ink.base,
    text: lighttheme.ink.base,
    muted: lighttheme.ink.light,
    link: lighttheme.secondary.accent,
    background: lighttheme.white,
    border: lighttheme.neutral.base,
    success: lighttheme.success.base,
    warning: lighttheme.attention.base,
    error: lighttheme.warning.base,
    sidebar: {
        bg: lighttheme.white,
        header: lighttheme.ink.lighter,
        navSearchBorder: lighttheme.neutral.light,
        navSearchIcon: lighttheme.ink.light,
        navGroup: lighttheme.ink.base,
        navLink: lighttheme.secondary.accent,
        navLinkActive: lighttheme.black,
        tocLink: lighttheme.ink.base,
        tocLinkActive: lighttheme.black,
    },
    code: {
        bg: 'hsl(216, 20%, 12%)'
    },
    header: {
        text: lighttheme.ink.base,
        border: colors.grayDark,
        button: {
            bg: lighttheme.secondary.base,
            color: lighttheme.white,
        },
    },
    props: {
        bg: colors.grayUltraLight,
        text: colors.grayDark,
        highlight: colors.blue,
        defaultValue: colors.gray,
        descriptionText: colors.grayDark,
        descriptionBg: colors.white,
    },
    playground: {
        bg: colors.white,
        border: colors.grayLight,
    },
    blockquote: {
        bg: lighttheme.neutral.light,
        border: lighttheme.secondary.light,
        color: lighttheme.ink.base,
    },
    // prism: { ...prismLight, },
};

export const dark = {
    // ...colors,
    primary: darktheme.secondary.accent,
    secondary: darktheme.ink.base,// To revise
    text: darktheme.ink.base,
    muted: darktheme.ink.light,
    link: darktheme.secondary.accent,
    background: darktheme.neutral.base,
    border: darktheme.neutral.lighter,
    success: darktheme.success.base,
    warning: darktheme.attention.base,
    error: darktheme.warning.base,
    sidebar: {
        bg: darktheme.neutral.dark,
        header: darktheme.ink.darker,
        navSearchBorder: darktheme.neutral.light,
        navSearchIcon: darktheme.ink.dark,
        navGroup: darktheme.ink.base,
        navLink: darktheme.secondary.accent,
        navLinkActive: darktheme.ink.base,
        tocLink: darktheme.ink.base,
        tocLinkActive: darktheme.secondary.light,
    },
    code: {
        bg: 'hsl(216, 20%, 12%)'
    },
    header: {
        text: darktheme.ink.base,
        border: colors.grayDark,
        button: {
            bg: colors.skyBlue,
            color: colors.white,
        },
    },
    props: {
        bg: colors.dark,
        text: colors.gray,
        highlight: colors.skyBlue,
        defaultValue: colors.grayDark,
        descriptionText: colors.gray,
        descriptionBg: colors.grayExtraDark,
    },
    playground: {
        bg: colors.dark,
        border: colors.grayDark,
    },
    blockquote: {
        bg: colors.grayDark,
        border: colors.gray,
        color: colors.gray,
    },
    // prism: { ...prismDark, },
};
